module.exports = __webpack_public_path__ + "img/example2.b4e2f76c.jpg";